import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { useClassNameFactory } from "@contember/react-utils";
import { dataAttribute, isNumber } from "@contember/utilities";
import { memo, forwardRef } from "react";
import { Label } from "../Typography/Label.js";
import { Box } from "../Box/Box.js";
import { Icon } from "../Icon/Icon.js";
const repeaterItemContainerClassNameBase = "repeater-item-container";
const RepeaterItemContainer = memo(forwardRef(({ actions, gap, children, label, dragHandleComponent: Handle, index, className: classNameProp, componentClassName = repeaterItemContainerClassNameBase, ...rest }, forwardedRef) => {
  const className = useClassNameFactory(componentClassName);
  return /* @__PURE__ */ jsxs(
    Box,
    {
      ref: forwardedRef,
      ...rest,
      className: className(null, classNameProp),
      gap: gap ?? "gutter",
      "data-index": dataAttribute(index),
      "data-sortable": dataAttribute(!!Handle),
      header: isNumber(index) || label || actions ? /* @__PURE__ */ jsx(RepeaterItemContainerHeader, { index, label, actions }) : null,
      children: [
        Handle && /* @__PURE__ */ jsx("div", { className: className("handle"), children: /* @__PURE__ */ jsx(Handle, { children: /* @__PURE__ */ jsx(Icon, { blueprintIcon: "drag-handle-vertical" }) }) }),
        children
      ]
    }
  );
}));
RepeaterItemContainer.displayName = "RepeaterItemContainer";
const RepeaterItemContainerHeader = memo(({ label, actions, index }) => {
  const className = useClassNameFactory(repeaterItemContainerClassNameBase);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    typeof label === "string" || typeof label === "number" || typeof label === "boolean" || label == null ? (label || index !== void 0) && /* @__PURE__ */ jsxs(Label, { className: className("label"), children: [
      label,
      label ? " " : "",
      index !== void 0 && /* @__PURE__ */ jsx("span", { className: className("index"), children: index + 1 })
    ] }) : label,
    actions && /* @__PURE__ */ jsx("div", { className: className("actions"), children: actions })
  ] });
});
export {
  RepeaterItemContainer,
  RepeaterItemContainerHeader
};
//# sourceMappingURL=RepeaterItemContainer.js.map
